import { render, staticRenderFns } from "./RepasseProfissionais.vue?vue&type=template&id=1afd89ac"
import script from "./RepasseProfissionais.vue?vue&type=script&lang=js"
export * from "./RepasseProfissionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports